import { GetterTree } from "vuex";
import { IState } from "@/store";
import { ICurrency } from "@/models/constants";
import SupportedLocaleCodes from "@/locales";

const getters: GetterTree<{}, IState> = {
  // Validate by running eg `1234567.98.toLocaleString("zh-TW")` in console
  decimalSeparator: (s, g, rootState) => {
    switch (rootState.i18n.activeLocaleCode) {
      case SupportedLocaleCodes.AZ:
      case SupportedLocaleCodes.BG:
      case SupportedLocaleCodes.DA:
      case SupportedLocaleCodes.DE:
      case SupportedLocaleCodes.EL:
      case SupportedLocaleCodes.ES:
      case SupportedLocaleCodes.FR:
      case SupportedLocaleCodes.FR_CA:
      case SupportedLocaleCodes.ID:
      case SupportedLocaleCodes.IT:
      case SupportedLocaleCodes.NB:
      case SupportedLocaleCodes.NL:
      case SupportedLocaleCodes.PL:
      case SupportedLocaleCodes.PT:
      case SupportedLocaleCodes.RU:
      case SupportedLocaleCodes.TR:
      case SupportedLocaleCodes.UK:
        return ",";
      case SupportedLocaleCodes.EN:
      case SupportedLocaleCodes.EN_US:
      case SupportedLocaleCodes.ES_419:
      case SupportedLocaleCodes.HE:
      case SupportedLocaleCodes.JA:
      case SupportedLocaleCodes.UR:
      case SupportedLocaleCodes.ZH_TW:
        return ".";
      default:
        return undefined;
    }
  },
  // Validate by running eg `1234567.98.toLocaleString("zh-TW")` in console
  thousandsSeparator: (s, g, rootState) => {
    switch (rootState.i18n.activeLocaleCode) {
      case SupportedLocaleCodes.AZ:
      case SupportedLocaleCodes.DA:
      case SupportedLocaleCodes.DE:
      case SupportedLocaleCodes.EL:
      case SupportedLocaleCodes.ES:
      case SupportedLocaleCodes.ID:
      case SupportedLocaleCodes.IT:
      case SupportedLocaleCodes.NL:
      case SupportedLocaleCodes.PT:
      case SupportedLocaleCodes.TR:
        return ".";
      case SupportedLocaleCodes.EN:
      case SupportedLocaleCodes.EN_US:
      case SupportedLocaleCodes.ES_419:
      case SupportedLocaleCodes.HE:
      case SupportedLocaleCodes.JA:
      case SupportedLocaleCodes.UR:
      case SupportedLocaleCodes.ZH_TW:
        return ",";
      case SupportedLocaleCodes.BG:
      case SupportedLocaleCodes.FR:
      case SupportedLocaleCodes.FR_CA:
      case SupportedLocaleCodes.NB:
      case SupportedLocaleCodes.PL:
      case SupportedLocaleCodes.RU:
      case SupportedLocaleCodes.UK:
        return " ";
      default:
        return undefined;
    }
  },
  formatValue: (s, g, rootState) => (
    value: number,
    currency: ICurrency["code"]
  ): string => {
    try {
      // Locale should be an IETF BCP 47 language tag
      const locale = rootState.i18n.activeLocaleCode.replace("_", "-");
      return new Intl.NumberFormat(locale, {
        style: "currency",
        currency, // ISO 4217 currency code
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch {
      return `${value}`;
    }
  },
  trimTrailingZeros: (s, { decimalSeparator }) => (
    formattedValue: string
  ): string => {
    if (!decimalSeparator) return formattedValue;
    const regex = new RegExp(
      [
        `(?:\\${decimalSeparator}0{2})`, // Match escaped decimal separator + '00'
        `(\\s[\\D\\S]{1,3})?`, // Optionally match whitespace + `USD` | `£GB` | `₹` etc
        `$` // Match end of string
      ].join(""),
      "g"
    );
    return formattedValue.replace(regex, "$1");
  }
};

export default {
  namespaced: true,
  getters
};
